export default "/images/b01389690a03357a49c6b7dde2f4e2f9.avif";